import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import "../styles/OurOPDnetwork.scss";
import {
  Autocomplete,
  Box,
  Button,
  FormLabel,
  Grid,
  Modal,
  Paper,
  TextField,
  Typography,
  Tabs,
  Tab,
  Divider,
  Card,
  Pagination,
} from "@mui/material";
import networkmap from "../assets/Mappp1.png";
import { useFormik } from "formik";
import * as yup from "yup";
import clinicdemo from "../assets/clinicdemopic.svg";
import kmimage from "../assets/km'slogo.svg";
import config from "../config.json";
import Loader from "./Loader";
import Footer from "./Footer";
import {
  searchClinicsByLocationEnhanced,
  searchClinicWithPincodeAndCity,
} from "../services/customerOnboarding";
import { getCitiesListForDropdown } from "../services/clinicOnboarding";
import { CssTextField } from "../styles/textFields";
import { toast } from "react-toastify";
import { addPotentialCustomer, getListOfClinicCities } from "../services/login";
import LocationSearchOPDNetwork from "./LocationSearchOPDNetwork";
import LocationOn from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import DirectionsIcon from "@mui/icons-material/Directions";
import { LocationOff } from "@mui/icons-material";

const Schema = yup.object().shape({
  pincode: yup
    .number()
    .positive()
    .integer()
    .min(100000, "Please Enter Correct Pincode")
    .max(999999, "Pincode is Too Long"),
  city: yup.string(),
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
};

const OurOPDnetwork = () => {
  const [loading, setLoading] = useState(false);
  const [clinicData, setClinicData] = useState([]);
  const [checkClicked, setCheckClicked] = useState(false);
  const [cityNames, setCityNames] = useState([]);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [pincode, setPincode] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [selectedLatLong, setSelectedLatLong] = useState({
    latitude: "",
    longitude: "",
  });
  const [currentLocation, setCurrentLocation] = useState({
    latitude: "",
    longitude: "",
  });
  const [locationError, setLocationError] = useState(false);
  const [page, setPage] = useState(0); // starts from 0 as per API
  const [pageSize] = useState(10); // default size
  const [totalPages, setTotalPages] = useState(0);
  const handleOpen = () => {
    console.log("dhopen tjhe modal");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
    setNumber("");
    setEmail("");
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setClinicData([]);
    setCheckClicked(false);
    setFieldValue("pincode", "");

    // new things
    setPage(0);
  };
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
  } = useFormik({
    initialValues: {
      pincode: "",
      city: "",
    },
    validationSchema: Schema,
    onSubmit,
  });

  // async function onSubmit(values, actions) {
  //   console.log("values", values);
  //   if (!values.pincode && values.city) {
  //     console.log("onlycity");
  //     setLoading(true);
  //     try {
  //       setCheckClicked(true);
  //       const res = await searchClinicWithPincodeAndCity(values);
  //       const data = res.data;
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //         setLoading(false);
  //         setCheckClicked(false);
  //       } else {
  //         setClinicData([]);
  //       }
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   } else {
  //     setClinicData([]);
  //   }
  //   if (values.pincode && !values.city) {
  //     console.log("onlypincode");
  //     setLoading(true);
  //     try {
  //       setCheckClicked(true);
  //       const res = await searchClinicWithPincodeAndCity(values);
  //       const data = res.data;
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //         setLoading(false);
  //         setCheckClicked(false);
  //       } else {
  //         handleOpen();
  //         setClinicData([]);
  //       }
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   }
  //   if (values.pincode && values.city) {
  //     console.log("both");
  //     setLoading(true);
  //     try {
  //       setCheckClicked(true);
  //       const res = await searchClinicWithPincodeAndCity(values);
  //       const data = res.data;
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //         setLoading(false);
  //         setCheckClicked(false);
  //       } else {
  //         setClinicData([]);
  //       }
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   }
  // }

  // checking new submit values for new
  // async function onSubmit(values, actions) {
  //   console.log("values", values);
  //   console.log("tabValue", tabValue);

  //   if (tabValue === 0 && currentLocation) {
  //     const payload = {
  //       latitude: currentLocation.latitude,
  //       longitude: currentLocation.longitude,
  //       maxResults: 999,
  //       maxDistanceKm: 3000.0,
  //     };
  //     try {
  //       setCheckClicked(true);
  //       setLoading(true);
  //       const res = await searchClinicsByLocationEnhanced(payload);
  //       const data = res.data;
  //       console.log("user location search data", data);
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //       } else {
  //         setClinicData([]);
  //       }
  //     } catch (error) {
  //       console.log("user location search error", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   // Search by Pincode (Tab 0)
  //   if (tabValue === 1 && values.pincode) {
  //     const payload = {
  //       pincode: values.pincode,
  //       maxResults: 25,
  //       maxDistanceKm: 25.0,
  //     };
  //     try {
  //       setCheckClicked(true);
  //       setLoading(true);
  //       const res = await searchClinicsByLocationEnhanced(payload);
  //       const data = res.data;
  //       console.log("pincode search data", data);
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //       } else {
  //         setClinicData([]);
  //         handleOpen(); // Show modal if no clinics found
  //       }
  //     } catch (error) {
  //       console.log("pincode search error", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   // Search by City (Tab 1)
  //   if (tabValue === 2 && values.city) {
  //     const payload = {
  //       cityName: values.city,
  //       maxResults: 25,
  //       maxDistanceKm: 40.0,
  //     };
  //     try {
  //       setCheckClicked(true);
  //       setLoading(true);
  //       const res = await searchClinicsByLocationEnhanced(payload);
  //       const data = res.data;
  //       console.log("city search data", data);
  //       if (data && data.length > 0) {
  //         setClinicData(data);
  //       } else {
  //         setClinicData([]);
  //       }
  //     } catch (error) {
  //       console.log("city search error", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // }
  async function onSubmit(values, actions, newPage = 0) {
    console.log("values", values);
    console.log("tabValue", tabValue);
    setLoading(true);
    setCheckClicked(true);
    setClinicData([]);

    try {
      let payload = { page: newPage, pageSize, maxDistanceKm: 9999 };
      let res;

      if (
        tabValue === 0 &&
        currentLocation.latitude &&
        currentLocation.longitude
      ) {
        // 🔹 Search Near Me
        payload = {
          ...payload,
          latitude: currentLocation.latitude,
          longitude: currentLocation.longitude,
        };
      } else if (tabValue === 1 && values.pincode) {
        // 🔹 Search by Pincode
        payload = { ...payload, pincode: values.pincode };
      } else if (tabValue === 2 && values.city) {
        // 🔹 Search by City
        payload = { ...payload, cityName: values.city };
      } else {
        setLoading(false);
        return;
      }

      res = await searchClinicsByLocationEnhanced(payload);
      const data = res.data;

      console.log("Paginated clinic data:", data);

      if (data?.clinics && data.clinics.length > 0) {
        setClinicData(data);
        setTotalPages(data.totalPages || 0);
      } else {
        // setClinicData([]);
        setClinicData({ clinics: [] });
        if (tabValue === 1) {
          handleOpen();
        }
      }

      setPage(newPage);
    } catch (error) {
      console.log("search error", error);
    } finally {
      setLoading(false);
    }
  }

  async function potentialClientsInfo() {
    const { data } = await addPotentialCustomer({
      name: name,
      mobileNumber: number,
      emailId: email,
      pincode: pincode,
    });
    console.log("data: ", data);
    if (data === "Sucessfully Added.") {
      handleClose();
      toast.success("Sucessfully Submitted", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setFieldValue("pincode", "", true);
    } else {
      toast.error("Some Error Occoured, please try again later", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  useEffect(() => {
    const fetchCityNames = async () => {
      setLoading(true);
      try {
        const response = await getListOfClinicCities();
        const data = response.data;
        setCityNames(data);
      } catch (error) {
        console.error("Error fetching clinic names:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCityNames();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLocationError(false);
          console.log("current location", currentLocation);
        },
        () => setLocationError(true)
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
      setLocationError(true);
    }
  }, []);
  return (
    <div className="opdnetworkcontent">
      <Navbar />
      <Box className="ouropdnetworkmainbody">
        <Box className="headingbox">
          <h2>Tron OPD Network</h2>
          <p>
            Our OPD offerings are designed to provide you with the best of
            healthcare in your local area. Enter your city and pincode to see
            your nearest clinic.
          </p>
        </Box>

        {/* old grid code for the right side */}

        {/* <Grid item sm={6} xs={12} md={6} lg={6}>
            <Box className="rightbox">
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6} xs={12} md={6}>
                    <FormLabel className="formlabel">Pincode</FormLabel>
                    <TextField
                      size="small"
                      placeholder="Pincode"
                      onChange={(e) => {
                        handleChange(e);
                        setPincode(e.target.value);
                      }}
                      onBlur={handleBlur}
                      name="pincode"
                      fullWidth
                      id="pincode"
                      sx={{ backgroundColor: "#ffffff" }}
                      value={values.pincode}
                    />
                    {errors.pincode && touched.pincode && (
                      <span style={{ color: "red", fontSize: "10px" }}>
                        {errors.pincode}
                      </span>
                    )}
                  </Grid>
                  <Grid item sm={6} xs={12} md={6}>
                    <FormLabel className="formlabel">City Name</FormLabel>
                    <Autocomplete
                      size="small"
                      options={cityNames}
                      loading={loading}
                      onChange={(e, newValue) =>
                        setFieldValue("city", newValue ? newValue : "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select City"
                          name="city"
                          id="city"
                          sx={{ backgroundColor: "#ffffff" }}
                          value={values.city}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Button
                  sx={{
                    backgroundColor: "#2d256c",
                    textAlign: "center",
                    color: "#FFFFFF",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    padding: "8px 15px",
                    marginTop: "10px",
                    height: "40px",
                    borderRadius: "3px",
                    "&:hover": { backgroundColor: "#2d256c!important" },
                  }}
                  type="submit"
                >
                  Search
                </Button>
              </form>
              {clinicData?.length > 0 && (
                <p style={{ color: "#d83f87", fontSize: "14px", mt: "10px" }}>
                  {clinicData?.length} Clinics found in your area.
                </p>
              )}

              <Box className="clinicsContainer">
                {checkClicked && clinicData.length === 0 ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <p>No Results Found</p>
                  </Box>
                ) : (
                  <Box className="clinicsmainbox">
                    {clinicData?.map((el, id) => {
                      return (
                        <Box className="carddata">
                          <Box className="leftside">
                            {el.imageUrl === null ? (
                              <img src={clinicdemo} alt="clinicpic" />
                            ) : (
                              <img
                                src={config.imageUrl + el.imageUrl}
                                alt="clinicpic"
                                className="clinicmainpic"
                              />
                            )}
                          </Box>
                          <Box className="rightside">
                            <h5>{el.clinicName}</h5>
                            <h6>{el.category}</h6>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "20px",
                              }}
                            >
                              <Box className="kmsbox">
                                {el.distance !== 0 ? (
                                  <>
                                    <img src={kmimage} alt="kmsimage" />
                                    <br />
                                    <p>
                                      {Math.round(parseInt(el.distance))} Kms
                                    </p>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Box>
                              <h6 className="address">{el.address}</h6>
                            </Box>
                            <Box className="specialitybox">
                              {el?.clinicType?.split(",").map((item, index) => (
                                <p key={index}>{item}</p>
                              ))}
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                    {loading ? (
                      <>
                        <Loader />
                      </>
                    ) : (
                      ""
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Grid> */}

        {/* New grid code for checking lat long values with gmap */}
        <Grid className="contentbody" container spacing={2}>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Box className="rightbox">
              <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="search tabs"
                  variant="scrollable" // ✅ makes tabs scrollable
                  scrollButtons="auto" // ✅ shows arrows when needed
                  allowScrollButtonsMobile
                >
                  <Tab label="Search near me" />
                  <Tab label="Search by Pincode" />
                  <Tab label="Search by City" />
                </Tabs>
              </Box>

              {/* Tab Panel for search near me */}
              {tabValue === 0 && (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      {/* <p
                        style={{
                          fontSize: "14px",
                          color: "#555",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <LocationOn sx={{ color: "#2d256c" }} /> Click below to
                        find clinics near you.
                      </p> */}
                      {locationError ? (
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#d32f2f",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <LocationOff sx={{ color: "#d32f2f" }} />
                          Please enable your location to find nearby clinics.
                        </p>
                      ) : (
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#555",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <LocationOn sx={{ color: "#2d256c" }} />
                          Click below to find clinics near you.
                        </p>
                      )}

                      <Button
                        sx={{
                          backgroundColor: "#2d256c",
                          textAlign: "center",
                          color: "#FFFFFF",
                          textTransform: "capitalize",
                          fontSize: "12px",
                          padding: "8px 15px",
                          marginTop: "10px",
                          height: "40px",
                          borderRadius: "3px",
                          "&:hover": { backgroundColor: "#2d256c!important" },
                        }}
                        type="submit"
                        disabled={locationError}
                        fullWidth
                      >
                        Search Nearby Clinics
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}

              {/* Tab Panel for Pincode Search */}
              {tabValue === 1 && (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormLabel className="formlabel">Pincode</FormLabel>
                      <TextField
                        size="small"
                        placeholder="Enter Pincode"
                        onChange={(e) => {
                          handleChange(e);
                          setPincode(e.target.value);
                        }}
                        onBlur={handleBlur}
                        name="pincode"
                        fullWidth
                        id="pincode"
                        sx={{ backgroundColor: "#ffffff" }}
                        value={values.pincode}
                      />
                      {errors.pincode && touched.pincode && (
                        <span style={{ color: "red", fontSize: "10px" }}>
                          {errors.pincode}
                        </span>
                      )}
                    </Grid>
                  </Grid>
                  <Button
                    sx={{
                      backgroundColor: "#2d256c",
                      textAlign: "center",
                      color: "#FFFFFF",
                      textTransform: "capitalize",
                      fontSize: "12px",
                      padding: "8px 15px",
                      marginTop: "10px",
                      height: "40px",
                      borderRadius: "3px",
                      "&:hover": { backgroundColor: "#2d256c!important" },
                    }}
                    type="submit"
                    fullWidth
                  >
                    Search by Pincode
                  </Button>
                </form>
              )}

              {/* Tab Panel for City Search */}
              {tabValue === 2 && (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item sm={12} xs={12} lg={12}>
                      <FormLabel className="formlabel">City Name</FormLabel>
                      <Autocomplete
                        size="small"
                        options={cityNames}
                        loading={loading}
                        onChange={(e, newValue) =>
                          setFieldValue("city", newValue ? newValue : "")
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select City"
                            name="city"
                            id="city"
                            sx={{ backgroundColor: "#ffffff" }}
                            value={values.city}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    sx={{
                      backgroundColor: "#2d256c",
                      textAlign: "center",
                      color: "#FFFFFF",
                      textTransform: "capitalize",
                      fontSize: "12px",
                      padding: "8px 15px",
                      marginTop: "10px",
                      height: "40px",
                      borderRadius: "3px",
                      "&:hover": { backgroundColor: "#2d256c!important" },
                    }}
                    type="submit"
                    fullWidth
                  >
                    Search by City
                  </Button>
                </form>
              )}

              {/* Clinic Results Display */}
              {clinicData?.clinics?.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <p
                    style={{
                      color: "#d83f87",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    {clinicData?.totalElements} Clinics found in your area.
                  </p>

                  <Box className="clinicsContainer">
                    <Box className="clinicsmainbox">
                      {clinicData?.clinics?.map((el, id) => {
                        return (
                          <Card key={id} sx={{ marginBottom: "5px" }}>
                            <Box className="carddata">
                              <Box className="leftside">
                                {el.imageUrl === null ? (
                                  <img src={clinicdemo} alt="clinicpic" />
                                ) : (
                                  <img
                                    src={config.imageUrl + el.imageUrl}
                                    alt="clinicpic"
                                    className="clinicmainpic"
                                  />
                                )}
                              </Box>
                              <Box className="rightside">
                                <div className="clinicnamebox">
                                  <div>
                                    <h5>{el.clinicName}</h5>
                                    <h6
                                      style={{
                                        backgroundColor:
                                          el.category === "Premium"
                                            ? "#fef9c3"
                                            : el.category === "Affordable"
                                            ? "#dcfce7"
                                            : el.category === "Ultra Premium"
                                            ? "#e0e7ff"
                                            : el.category === "Preferred"
                                            ? "#ffedd5"
                                            : "#f3f4f6", // fallback
                                        color:
                                          el.category === "Premium"
                                            ? "#92400e"
                                            : el.category === "Affordable"
                                            ? "#166534"
                                            : el.category === "Ultra Premium"
                                            ? "#3730a3"
                                            : el.category === "Preferred"
                                            ? "#9a3412"
                                            : "#374151", // fallback
                                        display: "inline-block",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {el.category}
                                    </h6>
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "10px",
                                      fontWeight: 800,
                                    }}
                                  >
                                    {el.distance < 1
                                      ? `${Math.round(
                                          el.distance * 1000
                                        )} meters`
                                      : `${Math.round(
                                          parseInt(el.distance)
                                        )} Kms`}
                                  </p>
                                </div>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    mt: "5px",
                                    // gap: "20px",
                                  }}
                                >
                                  <Box className="addressbox">
                                    {el.distance !== 0 ? (
                                      <>
                                        {/* <img
                                        src={kmimage}
                                        alt="kmsimage"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          setSelectedLatLong({
                                            latitude: el.latitude,
                                            longitude: el.longitude,
                                          })
                                        }
                                      /> */}
                                        <LocationOn />

                                        {/* <p style={{ fontSize: "10px" }}>
                                        {el.distance < 1
                                          ? `${Math.round(
                                              el.distance * 1000
                                            )} meters`
                                          : `${Math.round(
                                              parseInt(el.distance)
                                            )} Kms`}
                                      </p> */}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                  <h6 className="address">{el.address}</h6>
                                </Box>
                                <Box className="specialitybox">
                                  {el?.clinicType
                                    ?.split(",")
                                    .map((item, index) => (
                                      <p key={index}>{item}</p>
                                    ))}
                                </Box>
                              </Box>
                            </Box>
                            <Divider orientation="horizontal" flexItem />
                            <Grid
                              container
                              spacing={2}
                              className="directionsAndPhoneGrid"
                            >
                              <Grid item sm={6} xs={6} lg={6}>
                                <p className="phoneParagraph">
                                  <PhoneIcon style={{ fontSize: "12px" }} />{" "}
                                  {el.frontDeskNumber ? (
                                    <a
                                      href={`tel:${el.frontDeskNumber}`}
                                      className="phoneLink"
                                    >
                                      {el.frontDeskNumber}
                                    </a>
                                  ) : (
                                    <Typography
                                      variant="caption"
                                      sx={{ fontSize: "12px", color: "#888" }}
                                    >
                                      No number
                                    </Typography>
                                  )}
                                </p>
                                <p className="phoneParagraph">
                                  <PhoneIcon style={{ fontSize: "12px" }} />{" "}
                                  {el.pocNumber ? (
                                    <a
                                      href={`tel:${el.pocNumber}`}
                                      className="phoneLink"
                                    >
                                      {el.pocNumber}
                                    </a>
                                  ) : (
                                    <Typography
                                      variant="caption"
                                      sx={{ fontSize: "12px", color: "#888" }}
                                    >
                                      No number
                                    </Typography>
                                  )}
                                </p>
                              </Grid>
                              <Grid
                                item
                                sm={6}
                                xs={6}
                                lg={6}
                                sx={{ textAlign: "right" }}
                              >
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    setSelectedLatLong({
                                      latitude: el.latitude,
                                      longitude: el.longitude,
                                    });
                                  }}
                                  className="getDirectionsButton"
                                >
                                  <DirectionsIcon
                                    style={{ fontSize: "12px" }}
                                  />
                                  Get Directions
                                </Button>
                              </Grid>
                            </Grid>
                          </Card>
                        );
                      })}
                    </Box>
                  </Box>
                  <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                      count={clinicData?.totalPages || 0}
                      page={(clinicData?.currentPage || 0) + 1}
                      onChange={(event, page) =>
                        onSubmit(values, null, page - 1)
                      }
                      color="primary"
                    />
                  </Box>
                </Box>
              )}

              {/* No Results Message */}
              {/* {tabValue === 2 && clinicData.length === 0 && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <p>No Results Found</p>
                </Box>
              )} */}
              {(tabValue === 0 || tabValue === 2) &&
                checkClicked &&
                !loading &&
                clinicData.clinics.length === 0 && (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                  >
                    <p>No Results Found</p>
                  </Box>
                )}

              {/* Loading State */}
              {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                  <Loader />
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <LocationSearchOPDNetwork
              selectedLatLong={selectedLatLong}
              clinicData={clinicData}
            />
          </Grid>
        </Grid>
        {/* illustration */}
        <Grid className="contentbody" container spacing={3}>
          <Grid item sm={12} xs={12} md={12} lg={12}>
            <Box className="leftbox">
              <img src={networkmap} alt="OPD-Service" />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Footer />

      {/* -----------------------------Modal----------------------------- */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            We're not available in this area yet, but we'll let you know once
            this pin code joins the Tron network.
          </Typography>
          <Typography mt={1} mb={1} variant="subtitle2" fontWeight="bold">
            Name
          </Typography>
          <CssTextField
            fullWidth
            size="small"
            placeholder="Enter Name"
            variant="outlined"
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Typography mt={1} mb={1} variant="subtitle2" fontWeight="bold">
            Email
          </Typography>
          <CssTextField
            fullWidth
            size="small"
            placeholder="Enter Email"
            variant="outlined"
            type="text"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <Typography mt={1} mb={1} variant="subtitle2" fontWeight="bold">
            Mobile Number
          </Typography>
          <CssTextField
            fullWidth
            size="small"
            placeholder="Enter Number"
            variant="outlined"
            type="number"
            value={number}
            onChange={(e) => {
              setNumber(e.target.value);
            }}
          />
          <br />
          <br />
          <Button
            variant="contained"
            type="submit"
            sx={{
              width: "15em",
              backgroundColor: "#2d256c!important",
              fontSize: "12px",

              padding: "8px 15px",
              // marginLeft: "10px",
            }}
            onClick={() => name && email && number && potentialClientsInfo()}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default OurOPDnetwork;
